export enum FileTypes {
    EXCEL = 'Excel',
    CSV = 'Csv'
}
